<template>
	<div class="user_pay">
		<div class="quick_content_box3 box_h justify-between">
			<div class="quick_user_opration">
				<div class="quick_user_inputbox box_h">
					<!-- 投注倍数 -->
					<div class="quick_user_input1 box_h" style="margin-right: 0">
						<span>已选&nbsp;<strong v-text="betnum" style="color: #e9537a" />&nbsp;注</span>
						<span>&emsp;共&ensp;<strong style="color: #e9537a" v-text="betmoney.toFixed(3)" />&ensp;元</span>
						<div class="moubttype">
							<label>模式：</label>
							<el-select v-model="selectId" @change="SelectMount()">
								<el-option v-for="item in mounttype" :key="item.Rate" :label="item.Name" :value="item.Id"> </el-option>
							</el-select>
						</div>
						<div class="comput_flod">
							<a href="javascript:void(0)" class="quick_reduce" @click="quickReduce"><i class="el-icon-minus" /></a>
							<input type="number" min="1" v-model="Magnification" />
							<a class="quick_add" @click="quickAdd"><i class="el-icon-plus" /></a>
						</div>
					</div>
				</div>
			</div>
			<div class="user_btn_box">
				<el-button type="primary" @click="Dirbet">快速投注</el-button>
				<el-button plain @click="changeNum">添加号码</el-button>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		betnum: {
			type: Number,
			required: true,
		},
		betmoney: {
			type: Number,
			required: true,
		},
		userselect: {
			type: Array,
			required: true,
		},
		mounttype: {
			type: Array,
			required: true,
		},
		balance: {
			type: Number,
			required: true,
		},
		mult: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			mountName: "2元", //选择的下注金额单位
			arrowBot: false, //下拉框状态
			Magnification: this.mult, //倍率
			MagniAry: ["1", "5", "10", "15", "20"], //选择倍数
			selectId: 1, //默认模式为2元
		};
	},
	created() {
		window.eventBus.$on("addNum2Allin", () => {
			this.allBet();
		});
		this.$nextTick(() => {
			if (this.mounttype.length === 0) return; // 判空退出,抑制报错
			this.selectId = this.mounttype[0].Id;
			this.$emit("typeset", this.mounttype[0].Name); //默认选中两元`
			let sessSelectId = window.sessionStorage.getItem("userPaySelectId");
			if (sessSelectId) {
				this.selectId = parseInt(sessSelectId);
				let name = this.mounttype.filter(item => {
					if (item.Id == parseInt(sessSelectId)) {
						return item;
					}
				});
				this.$emit("typeset", name[0].Name); //默认选中两元
			}
		});
	},
	methods: {
		// 显示下拉框
		showArrow() {
			this.arrowBot = true;
		},
		hideMagni() {
			this.arrowBot = false;
		},
		//选择倍率
		selectMagni(e) {
			this.Magnification = parseInt(e.target.dataset.value);
			this.arrowBot = false;
			this.$emit("gamemultiply", this.Magnification);
		},
		//奖金调节
		adjustMent(e) {
			let value = e.target.value;
			this.$emit("bonus", value);
		},
		//选择模式
		SelectMount() {
			this.mounttype.forEach(item => {
				if (item.Id == this.selectId) {
					this.mountName = item.Name;
				}
			});
			this.$emit("typeset", this.mountName);
			window.sessionStorage.setItem("userPaySelectId", this.selectId);
		},
		// 增加倍率
		quickAdd() {
			let that = this;
			let num = that.mult;
			num = parseInt(num) + 1;
			that.Magnification = num;
			this.$emit("gamemultiply", that.Magnification);
		},
		//减少倍率
		quickReduce() {
			let that = this;
			let num = that.mult;
			if (num > 1) {
				num = num - 1;
				that.Magnification = num;
				this.$emit("gamemultiply", that.Magnification);
			} else if (num == 0) {
				that.Magnification = "";
				this.$emit("gamemultiply", that.Magnification);
			}
		},
		// 一键投注
		Dirbet() {
			this.$emit("dirbet");
		},
		// 一键梭哈
		allBet() {
			this.$emit("allin");
		},
		// 添加号码
		changeNum() {
			window.eventBus.$emit("newVersionAddNum");
		},
	},
	watch: {
		mult: function () {
			this.Magnification = this.mult;
		},
		Magnification(val) {
			this.arrowBot = false;
			let num = 0;
			if (val == "" || val == "NaN") {
				this.Magnification = "";
				num = 0;
			} else {
				this.Magnification = parseInt(val);
				num = parseInt(this.Magnification);
			}
			this.$emit("gamemultiply", num);
		},
		mounttype() {
			this.$emit("typeset", this.mounttype[0].Name); //默认选中两元
			this.selectId = this.mounttype[0].Id;
			let sessSelectId = window.sessionStorage.getItem("userPaySelectId");
			if (sessSelectId) {
				this.selectId = parseInt(sessSelectId);
				let name = this.mounttype.filter(item => {
					if (item.Id == parseInt(sessSelectId)) {
						return item;
					}
				});
				this.$emit("typeset", name[0].Name); //默认选中两元
			}
		},
	},
};
</script>
<style>
.user_pay .el-button--default {
	position: relative;
	border-radius: 3px;
	/* background: linear-gradient(-45deg, #0e78c7, #66bcfc); */
	/* background-color: #66bcfc; */
	border: 1.5px solid #6455fe;
	/* border: none; */
}
.user_pay .el-button--default::before {
	content: "添加号码";
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 97%;
	height: 94%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	font-size: 15px;
	color: #6455fe;
	border-radius: 3px;
}

.user_pay .el-input-number__decrease,
.el-input-number__increase {
	background: none !important;
}
.user_btn_box .el-button {
	padding: 0;
	width: 90px;
	height: 40px;
}
.quick_content_box3 {
	width: 100%;
	padding: 18px 0px 0;
	border-top: 1px solid #f0f0f0;
}

.quick_user_opration {
	padding-top: 7px;
	padding-left: 20px;
	font-size: 14px;
}

.quick_user_inputbox {
	color: #575757;
}

.quick_payfor_box {
	overflow: hidden;
	font-size: 12px;
	padding: 0 20px;
}

.quick_payfor_box strong {
	font-size: 16px;
	color: #ec362b;
	margin: 0 2px;
}

.quick_user_input1 {
	font-size: 0;
	justify-content: center;
	align-items: center;
	margin-right: 10px;
}

.quick_user_input2 {
	justify-content: center;
	align-items: center;
	overflow: hidden;
}

.quick_user_input1 > span,
.quick_user_input2 > span {
	color: #555;
	font-size: 14px;
	vertical-align: middle;
	margin-right: 10px;
}
.quick_user_input1 > span > strong,
.quick_user_input2 > span > strong {
	font-family: "HiraginoSansGB-W3";
	font-weight: 400;
}

.moubttype {
	display: flex;
	justify-content: space-between;
	width: 120px;
	height: 28px;
	border-radius: 3px;
	margin-left: 80px;
	margin-right: 5px;
	transition: all 0.3s;
	/* box-shadow: inset 5.7px 5.7px 6px 0 rgba(0, 0, 0, 0.03); */
	/* background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa); */
	background-color: #fff;
	border-radius: 3px;
	border: solid 1px #dedede;
	align-items: flex-start;
}

.moubttype:hover {
	border-color: #0e78c7;
}

.moubttype label {
	width: 50px;
	height: 30px;
	line-height: 28px;
	text-align: left;
	font-size: 13px;
	color: #555;
	margin-left: 10px;
}
.moubttype .el-select {
	width: 58px;
	height: 30px;
}
.moubttype .el-select .el-input__inner {
	height: 26px;
	line-height: 28px;
	border: none;
	padding: 0;
	color: #555;
	font-size: 13px;
	/* box-shadow: inset 5.7px 5.7px 6px 0 rgba(0, 0, 0, 0.03);
	background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa); */
	background-color: #fff;
	border-radius: 3px;
	padding-top: 2px;
}
.moubttype .el-select .el-input__suffix .el-input__suffix-inner i {
	color: #ccc !important;
	transition: all 0.3s;
}
.moubttype .el-select .el-input__suffix .el-input__suffix-inner i:hover {
	color: #ccc !important;
}

.quick_user_input1 .arrow_bottom_box {
	width: 50px;
	position: absolute;
	background: #fff;
	top: 30px;
	left: -7px;
	z-index: 666;
	border: 1px solid #eaeaea;
	height: 112px;
}

.quick_user_input1 .arrow_bottom_box > span {
	display: block;
	text-align: center;
	line-height: 22px;
	color: #000;
	font-size: 14px;
	cursor: pointer;
}

.quick_user_input1 .arrow_bottom_box > span:hover {
	background: #1f7877;
	color: white;
}

.comput_flod {
	display: flex;
	justify-content: space-between;
	width: 96px;
	height: 28px;
	border: 1px solid #e8e8e8;
	border-radius: 4px;
	overflow: hidden;
}

.comput_flod a {
	display: block;
	width: 28px;
	height: 28px;
	color: #ccc;
	font-size: 14px;
	line-height: 28px;
	text-align: center;
	/* box-shadow: inset 5.7px 5.7px 6px 0 rgba(0, 0, 0, 0.03);
	background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa); */
	background-color: #fff;
}
.comput_flod a.quick_reduce {
	border-right: 1px solid #e8e8e8;
}
.comput_flod a.quick_add {
	border-left: 1px solid #e8e8e8;
}
.comput_flod input {
	width: 40px;
	height: 28px;
	line-height: 28px;
	border: none;
	outline: none;
	color: #606266;
	font-size: 16px;
	text-align: center;
	/* box-shadow: inset -3px 0px 6px 0 rgba(0, 0, 0, 0.08), inset 3px 0 6px 0 rgba(0, 0, 0, 0.08);
	background-image: linear-gradient(to top, #f5f8fa, #f1f1f1, #f5f8fa); */
	background-color: #fff;
}

.quick_user_input2 {
	display: flex;
	justify-content: center;
}

.quick_user_input2 > div {
	width: 30px;
	height: 30px;
	line-height: 30px;
	text-align: center;
	margin: 0 4px;
	color: #707070;
	font-size: 13px;
	background-color: #ffffff;
	border-radius: 3px;
	border: 1px solid #c6d1d0;
	cursor: pointer;
}

.quick_user_input2 > div.selected {
	color: #ffffff !important;
	background-color: #0e78c7 !important;
	border: none;
}

.quick_user_input2 select:focus {
	outline: none;
}

.user_pay input {
	font-family: "HiraginoSansGB-W3";
}
</style>



// WEBPACK FOOTER //
// src/components/Subcomponents/user_pay.vue